import React, { PropsWithChildren } from 'react';

export interface IProps {
  label: string;
  name: string;
}
export const TabContent: React.FC<PropsWithChildren<IProps>> = (props) => {
  return null;
};
